import { render } from "./App.vue?vue&type=template&id=df924a9c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=df924a9c&lang=less"
script.render = render

export default script